export class ContentControlledEditingDirectiveScreenshot {
  constructor(
    public id: number,
    public type: 'in' | 'out',
    public at: number,
    public video?: HTMLVideoElement,
    public screenshot?: string,
    public mediaId?: number,
  ) {}
}
